import React, { useState, useEffect } from 'react';
import useWindowSize from 'hooks/useWindowSize';
import { useAnimation } from 'framer-motion6';
import PropTypes from 'prop-types';
import { CardsContainer } from './styled';
import CardMobile from '../CardMobile';

const CardsMobile = ({ cards }) => {
  const marginRight = 32;
  const cardWidth = 240;

  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const trackControls = useAnimation();
  const { width: windowWidth } = useWindowSize();

  const getClosestSlide = (counts, goal) => {
    return counts.reduce((prev, curr) => {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
    });
  };

  const getOffsets = (cards, windowWidth) => {
    const cardWidths = cards.map(() => cardWidth + marginRight);

    let offsets = cardWidths.map((card, index) =>
      cardWidths.slice(0, index + 1).reduce((a, b) => a + b, 0)
    );

    offsets.unshift(0);
    offsets.pop();

    offsets = offsets.map((offset) => {
      return offset - windowWidth / 2 + cardWidth / 2;
    });

    return offsets;
  };

  const offsets = getOffsets(cards, windowWidth);

  const handleDrag = (target) => {
    const snapTarget = getClosestSlide(offsets, target * -1) * -1;

    const activeCardIndex = offsets.findIndex((offset) => offset === -snapTarget);

    setActiveCardIndex(activeCardIndex);

    return snapTarget;
  };

  useEffect(() => {
    const target = offsets[1];
    setActiveCardIndex(1);

    trackControls.start({ x: -target, transition: { duration: 0.01 } });
  }, []);

  useEffect(() => {
    if (isDragging) {
      setTimeout(() => {
        setIsDragging(false);
      }, 1000);
    }
  }, [isDragging]);

  return (
    <CardsContainer
      drag="x"
      dragTransition={{
        power: 0.1,
        timeConstant: 200,
        modifyTarget: handleDrag
      }}
      animate={trackControls}
    >
      {cards.map((card, index) => (
        <CardMobile
          photo={card?.photo}
          video={card?.video}
          type={card?.type}
          key={card?.id}
          isDragging={isDragging}
          name={card?.name}
          location={card?.location}
          description={card?.description}
          isActiveCard={index === activeCardIndex}
          marginRight={marginRight}
        />
      ))}
    </CardsContainer>
  );
};

export default CardsMobile;

CardsMobile.propTypes = {
  cards: PropTypes.array.isRequired
};
